import { z } from "zod";

export const createCreateProjectSchema = (isModer: boolean) =>
  z
    .object({
      name: z.string().min(1, "Поле обязательно для заполнения"),
      code: z.string().min(1, "Поле обязательно для заполнения"),
      description: z.string().min(1, "Поле обязательно для заполнения"),
      objectName: z.string().optional(),
      objectNameInput: z.string().optional(),
      objectNameSelect: z.string().nullable().optional(),
    })
    .superRefine((data, ctx) => {
      const hasAnyValue = !!(data.objectNameInput || data.objectNameSelect);

      if (!hasAnyValue) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: isModer ? "Обязательное поле для заполнения" : "Выберите из списка или введите вручную",
          path: ["objectNameSelect"],
        });

        if (!isModer) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Выберите из списка или введите вручную",
            path: ["objectNameInput"],
          });
        }
      }
    });

export type CreateProjectFormData = z.infer<ReturnType<typeof createCreateProjectSchema>>;

export type StepsProps = {
  step1: {
    title: string;
    status: "in_progress" | "done" | "pending";
    isActive: boolean;
  };
  step2: {
    isActive: boolean;
    title: string;
    status: "in_progress" | "done" | "pending";
  };
};
